import gql from 'graphql-tag';

export default gql`
fragment UserShippingAddressFragment on UserShippingAddress {
    id
    name
    postcode
    city
    street
    house_number
    is_default
    note
    telephone
}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/fragments/UserShippingAddressFragment.ts